import { FeatureFlagNameEnum } from "@/services/internalApiV1";
import type { RouteRecordRaw } from "vue-router";

export const sharedFoldersRoutes: RouteRecordRaw[] = [
  {
    path: "/shared-folders",
    name: "shared-folders-index",
    component: () => import("./SharedFolderListPage.vue"),
    meta: {
      requiresAuth: true,
      requiresTeacher: true,
    },
  },
  // Static route before the dynamic `:id`, or "discarded" resolves as a folder
  // id and the detail page asks the API for a node that cannot exist.
  {
    path: "/shared-folders/discarded",
    name: "shared-folders-discarded",
    component: () => import("./discarded/SharedFolderDiscardedPage.vue"),
    meta: {
      requiresAuth: true,
      requiresTeacher: true,
    },
    // Flag off, the footer link is dormant — so is the URL. `beforeEnter`
    // rather than a `meta.requiresFeature` hook: one route needs it so far.
    // The user is seeded from `data-user` in `main.ts`, so the flag answers
    // synchronously here.
    beforeEnter: () =>
      useUserStore().isFeatureEnabled(FeatureFlagNameEnum.SHARED_LIBRARY_TRASH)
        ? true
        : { name: "shared-folders-index" },
  },
  {
    path: "/shared-folders/:id",
    name: "shared-folders-show",
    component: () => import("./[id]/SharedFolderDetailPage.vue"),
    meta: {
      requiresAuth: true,
      requiresTeacher: true,
    },
  },
];
